import React, { useState, useEffect, useRef, useMemo } from "react";
import styled from "styled-components";
import {
  Container,
  Row,
  Col,
  Table as BootstrapTable,
  Modal,
  Offcanvas,
  Form,
  Spinner,
} from "react-bootstrap";
import "./cardthree.css";
import ProductCardTwo from "../cardtwo/ProductCardTwo";
import {
  FaPlay,
  FaShoppingCart,
  FaTimes,
  FaChevronLeft,
  FaChevronRight,
  FaSearch,
  FaCheckCircle,
  FaTruck,
  FaClock,
  FaCalendarAlt,
  FaInfoCircle,
  FaExclamationTriangle,
} from "react-icons/fa";
import { Buttons, Close } from "../../components/Buttons/Buttons";
import { FaPlus, FaMinus } from "react-icons/fa6";
import PageTitle from "../../components/Buttons/PageTitle";
import { Forms, DropDowns } from "../../components/Forms";
import { PDFDownloadLink } from "@react-pdf/renderer";
import API_DOMAIN from "../../config/config";
import Bill from "../../pdf/Bill";
import combo2000 from "../../assets/images/combos/combo-2000.png";
import combo3000 from "../../assets/images/combos/combo-3000.png";
import combo5000 from "../../assets/images/combos/combo-5000.png";
import combo7000 from "../../assets/images/combos/combo-7000.png";

const comboPacks = [
  {
    id: "combo-2000",
    name: "₹2,000 Special Combo",
    price: 2000,
    badge: "Budget Friendly",
    image: combo2000,
  },
  {
    id: "combo-3000",
    name: "₹3,000 Mega Combo",
    price: 3000,
    badge: "Most Popular",
    image: combo3000,
  },
  {
    id: "combo-5000",
    name: "₹5,000 Super Jumbo Combo",
    price: 5000,
    badge: "Grand Celebration",
    image: combo5000,
  },
  {
    id: "combo-7000",
    name: "₹7,000 Royal Deluxe Combo",
    price: 7000,
    badge: "VIP Royal Deluxe",
    image: combo7000,
  },
];

const CardThree = ({
  products,
  category,
  selectedProduct,
  totals,
  addToCart,
  setShowVideoModal,
  showVideoModal,
  updateQuantity,
  handleShowCart,
  handleCloseCart,
  showCart,
  handleClose,
  handleShow,
  show,
  removeProduct,
  cart,
  districtData,
  companydata,
  setCart,
  setting,
  banner,
}) => {
  const [checkout, setCheckOut] = useState(false);
  const [showEstimate, setShowEstimate] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [printData, setPrintData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [previewCombo, setPreviewCombo] = useState(null);
  const carouselRef = useRef(null);

  const [alertModal, setAlertModal] = useState({
    show: false,
    title: "",
    message: "",
    type: "warning",
  });

  const showAlert = (title, message, type = "warning") => {
    setAlertModal({
      show: true,
      title,
      message,
      type,
    });
  };

  const closeAlert = () => {
    setAlertModal((prev) => ({ ...prev, show: false }));
  };

  const closeOut = () => setCheckOut(false);
  const showOut = () => setCheckOut(true);
  const closeModal = () => setShowEstimate(false);
  const showModal = () => setShowEstimate(true);

  const [formData, setFormData] = useState({
    state: "",
    city: "",
    name: "",
    email: "",
    mobile: "",
    address: "",
  });
  const [cityOptions, setCityOptions] = useState([]);

  const handleStateChange = (selectedOption) => {
    const state = selectedOption.value;
    setFormData((prevState) => ({
      ...prevState,
      state,
      city: "",
    }));

    const cities = districtData[state] || [];
    setCityOptions(cities.map((city) => ({ value: city, label: city })));
  };
  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const handleCityChange = (selectedOption) => {
    const city = selectedOption.value;
    setFormData((prevState) => ({
      ...prevState,
      city,
    }));
  };

  const handleChange = (e, fieldName) => {
    const value = e.target ? e.target.value : e.value;
    setFormData({
      ...formData,
      [fieldName]: value,
    });
  };

  const categoryOptions = [
    { value: "all", label: "All Product" },
    ...category.map((cat) => ({
      value: cat.id,
      label: cat.category_name,
    })),
  ];

  const handleCategoryChange = (selectedOption) => {
    setSelectedCategory(selectedOption.value);
  };

  const handleCategoryImageClick = (categoryId) => {
    setSelectedCategory(categoryId);
  };

  const getFirstProductImage = (categoryId) => {
    const categoryProducts = products.filter(
      (product) => product.category_id === categoryId
    );

    if (categoryProducts.length > 0) {
      const validProduct = categoryProducts.find((product) => product.img);
      return validProduct
        ? validProduct.img
        : require("../../assets/images/storelogo.png");
    }
  };

  const [showSuggestions, setShowSuggestions] = useState(false);

  const searchSuggestions = useMemo(() => {
    const q = searchQuery.trim().toLowerCase();
    if (!q) return [];
    return products
      .filter(
        (p) =>
          p.active === 1 &&
          (p.product_name.toLowerCase().includes(q) ||
            (p.product_content || "").toLowerCase().includes(q))
      )
      .slice(0, 8);
  }, [products, searchQuery]);

  const filteredProducts = useMemo(() => {
    const q = searchQuery.trim().toLowerCase();

    return products.filter((p) => {
      // Filter by category
      const categoryMatch =
        selectedCategory === "all" || p.category_id === selectedCategory;

      // Filter by search text
      const searchMatch =
        p.product_name.toLowerCase().includes(q) ||
        (p.product_content || "").toLowerCase().includes(q) ||
        String(p.price).includes(q);

      return categoryMatch && searchMatch;
    });
  }, [products, selectedCategory, searchQuery]);

  const handleSubmit = () => {
    if (!formData.state) {
      showAlert("State Required", "Please select your State to proceed with the estimate.", "warning");
      return;
    }
    if (!formData.name) {
      showAlert("Name Required", "Please enter your Name to proceed with the estimate.", "warning");
      return;
    }
    if (!formData.mobile) {
      showAlert("Mobile Number Required", "Please enter your Mobile Number.", "warning");
      return;
    }

    const minRequired = formData.state === "Tamil Nadu" ? 3000 : 5000;
    if (totals.discountRate < minRequired) {
      showAlert(
        "Minimum Order Requirement Not Met",
        `Minimum order required for ${formData.state} is ₹${minRequired.toLocaleString()}. Your current order total is ₹${totals.discountRate.toFixed(2)}. Please add ₹${(minRequired - totals.discountRate).toFixed(0)} more items to proceed.`,
        "warning"
      );
      return;
    }

    setIsSubmitting(true);

    fetch(`${API_DOMAIN}/online_enq_web.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        cart_pro: cart,
        customer_data: formData,
        total_products: totals.totalProducts,
        total_price: totals.discountRate.toFixed(2),
        total_discount: totals.overallTotal.toFixed(2),
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setIsSubmitting(false);
        if (data.head.code === 200) {
          setPrintData(data.body.data);
          showModal();
          setCart([]);
          setFormData({
            state: "",
            city: "",
            name: "",
            email: "",
            mobile: "",
            address: "",
          });
          closeOut();
        } else {
          showAlert("Order Error", data.head.msg || "Order submission failed.", "danger");
        }
      })
      .catch((error) => {
        setIsSubmitting(false);
        console.error("Error submitting order:", error);
        showAlert("Connection Error", "Network error while submitting your order. Please try again.", "danger");
      });
  };

  const extractVideoId = (url) => {
    const urlObj = new URL(url);
    if (urlObj.hostname === "youtu.be") {
      return urlObj.pathname.slice(1);
    } else if (
      urlObj.hostname === "youtube.com" ||
      urlObj.hostname === "www.youtube.com"
    ) {
      return urlObj.searchParams.get("v") || urlObj.pathname.split("/").pop();
    }
    return "";
  };

  const handleVideoModalShow = () => {
    console.log("Showing video modal");
    setShowVideoModal(true);
  };

  const handleVideoModalClose = () => {
    console.log("Closing video modal");
    setShowVideoModal(false);
  };

  const actionvalue = "minus";

  return (
    <>
      {/* ALL DEPARTMENT Header Strip */}
      <div className="department-title-strip">
        <Container fluid>
          <h3 className="section-title-department">ALL DEPARTMENT</h3>
        </Container>
      </div>

      <div className="top-control-bar-sticky">
        <Container fluid>
          {/* Top Control Bar: Search and Filters (50% / 50% split) */}
          <div className="top-control-bar">
            <div className="search-input-wrapper" style={{ position: "relative" }}>
              <input
                type="text"
                placeholder="Search an item..."
                value={searchQuery}
                onChange={(e) => {
                  handleSearchChange(e);
                  setShowSuggestions(true);
                }}
                onFocus={() => setShowSuggestions(true)}
                onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
              />
              {searchQuery ? (
                <FaTimes
                  className="search-icon clear-search-icon"
                  onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setSearchQuery("");
                    setShowSuggestions(false);
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setSearchQuery("");
                    setShowSuggestions(false);
                  }}
                />
              ) : (
                <FaSearch className="search-icon" />
              )}

              {showSuggestions && searchQuery.trim() && searchSuggestions.length > 0 && (
                <div
                  className="search-suggestions-dropdown"
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    backgroundColor: "#FFFFFF",
                    border: "2px solid #0D3B82",
                    borderRadius: "0 0 10px 10px",
                    boxShadow: "0 8px 25px rgba(13, 59, 130, 0.2)",
                    zIndex: 1100,
                    maxHeight: "280px",
                    overflowY: "auto",
                    marginTop: "2px",
                  }}
                >
                  {searchSuggestions.map((item) => (
                    <div
                      key={item.id}
                      className="suggestion-item p-2 border-bottom d-flex align-items-center justify-content-between"
                      style={{ cursor: "pointer", background: "#FFFFFF", transition: "background 0.2s" }}
                      onMouseDown={() => {
                        setSearchQuery(item.product_name);
                        setShowSuggestions(false);
                      }}
                    >
                      <div className="d-flex align-items-center gap-2">
                        {item.img && (
                          <img
                            src={item.img}
                            alt={item.product_name}
                            style={{ width: "32px", height: "32px", objectFit: "cover", borderRadius: "4px" }}
                          />
                        )}
                        <span className="fw-bold text-dark" style={{ fontSize: "0.85rem" }}>
                          {item.product_name}
                        </span>
                      </div>
                      <span className="badge bg-danger text-white ms-2" style={{ fontSize: "0.75rem" }}>
                        ₹{item.price}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="filter-dropdown-wrapper">
              <DropDowns
                options={categoryOptions}
                placeholder="Filters ▾"
                value={
                  categoryOptions.find(
                    (opt) => opt.value === selectedCategory
                  ) || null
                }
                onChange={handleCategoryChange}
              />
            </div>
          </div>
        </Container>
      </div>

      {/* Special Combo Section (Hidden as requested) */}
      {/* 
      <div className="combo-section-wrapper py-3">
        <Container fluid>
          <div className="combo-header-box mb-3 text-center">
            <div className="combo-fire-badge">✨ DIWALI SPECIAL COMBO PACKS ✨</div>
            <h4 className="combo-main-title">சிறப்பு பட்டாசு காம்போ பேக்குகள்</h4>
            <p className="combo-sub-desc">
              Click on any combo pack to view the complete items list in full high-resolution preview!
            </p>
          </div>

          <Row className="g-3 justify-content-center">
            {comboPacks.map((combo) => (
              <Col key={combo.id} xs={6} sm={6} md={3} lg={3}>
                <div
                  className="combo-card"
                  onClick={() => setPreviewCombo(combo)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") setPreviewCombo(combo);
                  }}
                  title={`Click to view full preview of ${combo.name}`}
                >
                  <div className="combo-badge-pill">{combo.badge}</div>
                  <div className="combo-image-holder">
                    <img
                      src={combo.image}
                      alt={combo.name}
                      className="combo-thumb-img"
                      loading="lazy"
                    />
                    <div className="combo-overlay-hover">
                      <span className="combo-overlay-btn">
                        <FaSearch className="me-1" /> Full Preview
                      </span>
                    </div>
                  </div>
                  <div className="combo-info-holder">
                    <h6 className="combo-name-text">{combo.name}</h6>
                    <div className="combo-hint-tag">Tap to view full list 👁️</div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
      */}

      {/* Modern Product Card Grid Section */}
      <div className="product-grid-wrapper py-3">
        <Container fluid className="px-2 px-md-3">
          {filteredProducts.length === 0 ? (
            <div className="text-center py-5">
              <h5 className="text-muted fw-bold">No products found matching your search.</h5>
              <button
                type="button"
                className="btn btn-outline-primary mt-2"
                onClick={() => {
                  setSearchQuery("");
                  setSelectedCategory("all");
                }}
              >
                View All Products
              </button>
            </div>
          ) : (
            category
              .filter((cat) => cat.website_active === 1)
              .filter(
                (cat) => selectedCategory === "all" || cat.id === selectedCategory
              )
              .map((cat) => {
                const categoryProducts = filteredProducts.filter(
                  (product) =>
                    product.category_id === cat.id && product.active === 1
                );
                if (categoryProducts.length === 0) return null;

                const catDiscount = cat.discount;

                return (
                  <div key={cat.id} className="category-section-block">
                    {/* Category Header Banner */}
                    <div className="category-header-banner">
                      <h5 className="category-header-title">
                        {cat.category_name.toUpperCase()}
                      </h5>
                      {catDiscount && Number(catDiscount) > 0 ? (
                        <span className="category-discount-tag">
                          {catDiscount}% DISCOUNT
                        </span>
                      ) : null}
                    </div>

                    {/* Responsive 2-column mobile, multi-column desktop grid */}
                    <Row className="g-2 g-md-3">
                      {categoryProducts.map((product) => {
                        const hasDiscount =
                          product.discount_lock === 0 &&
                          catDiscount &&
                          Number(catDiscount) > 0;

                        const netPrice = hasDiscount
                          ? Math.round(
                              product.price -
                                (product.price * Number(catDiscount)) / 100
                            )
                          : Math.round(product.price);

                        const discountPercent = hasDiscount
                          ? Number(catDiscount) ||
                            Math.round(
                              ((product.price - netPrice) / product.price) * 100
                            )
                          : 0;

                        const currentQty = product.qty || 0;

                        return (
                          <Col
                            xs={6}
                            sm={6}
                            md={4}
                            lg={3}
                            xl={2}
                            key={product.id}
                            className="d-flex align-items-stretch"
                          >
                            <div
                              className={`product-card-modern ${
                                currentQty > 0 ? "active-in-cart" : ""
                              }`}
                            >
                              {/* Round Red Discount Badge (matches screenshot 80% circle) */}
                              {hasDiscount && discountPercent > 0 && (
                                <div
                                  className="card-discount-circle"
                                  title={`${discountPercent}% Discount`}
                                >
                                  {discountPercent}%
                                </div>
                              )}

                              {/* Product Image Box */}
                              <div
                                className="card-image-box"
                                onClick={() => handleShow(product)}
                                role="button"
                                tabIndex={0}
                                title="Click to view large image"
                              >
                                <img
                                  src={
                                    product.img
                                      ? product.img
                                      : require("../../assets/images/storelogo.png")
                                  }
                                  alt={product.product_name || product.name}
                                  className="card-product-img"
                                  loading="lazy"
                                />
                              </div>

                              {/* Note: NO STARS - user explicitly requested: "antha product card la star la irugula athulam veyndam" */}

                              {/* Product Content Details */}
                              <div className="card-content-box">
                                <h6
                                  className="card-product-name"
                                  title={product.product_name || product.name}
                                >
                                  {product.product_name || product.name}
                                </h6>

                                {product.product_content && (
                                  <div className="card-product-pack">
                                    {product.product_content}
                                  </div>
                                )}

                                {/* Price Row */}
                                <div className="card-price-row">
                                  <span className="card-net-price">
                                    ₹{netPrice}.00
                                  </span>
                                  {hasDiscount && (
                                    <del className="card-actual-price">
                                      ₹{product.price}.00
                                    </del>
                                  )}
                                </div>

                                {/* Subtotal preview when qty > 0 */}
                                {currentQty > 0 && (
                                  <div className="card-subtotal-badge">
                                    Total: ₹{(netPrice * currentQty).toFixed(0)}
                                  </div>
                                )}

                                {/* + and - Quantity Stepper (as requested: "+ and - button vachuru") */}
                                <div className="card-qty-stepper">
                                  <button
                                    type="button"
                                    className="stepper-btn stepper-minus"
                                    onClick={() => {
                                      if (currentQty > 0) {
                                        updateQuantity(product.id, -1);
                                        addToCart({
                                          id: product.id,
                                          name:
                                            product.product_name || product.name,
                                          total_price: product.price,
                                          qty: currentQty - 1,
                                          discount: cat.discount,
                                          category_id: product.category_id,
                                          per_price: netPrice,
                                          product_content:
                                            product.product_content,
                                          img: product.img || null,
                                        });
                                      }
                                    }}
                                    disabled={currentQty <= 0}
                                    aria-label="Decrease quantity"
                                  >
                                    <FaMinus />
                                  </button>

                                  <input
                                    type="number"
                                    min="0"
                                    className="stepper-qty-input"
                                    value={currentQty === 0 ? "" : currentQty}
                                    placeholder="0"
                                    onChange={(e) => {
                                      const val = Math.max(
                                        0,
                                        parseInt(e.target.value) || 0
                                      );
                                      const diff = val - currentQty;
                                      if (diff !== 0) {
                                        updateQuantity(product.id, diff);
                                        addToCart({
                                          id: product.id,
                                          name:
                                            product.product_name || product.name,
                                          total_price: product.price,
                                          qty: val,
                                          discount: cat.discount,
                                          category_id: product.category_id,
                                          per_price: netPrice,
                                          product_content:
                                            product.product_content,
                                          img: product.img || null,
                                        });
                                      }
                                    }}
                                  />

                                  <button
                                    type="button"
                                    className="stepper-btn stepper-plus"
                                    onClick={() => {
                                      updateQuantity(product.id, 1);
                                      addToCart({
                                        id: product.id,
                                        name:
                                          product.product_name || product.name,
                                        total_price: product.price,
                                        qty: currentQty + 1,
                                        discount: cat.discount,
                                        category_id: product.category_id,
                                        per_price: netPrice,
                                        product_content:
                                          product.product_content,
                                        img: product.img || null,
                                      });
                                    }}
                                    aria-label="Increase quantity"
                                  >
                                    <FaPlus />
                                  </button>
                                </div>
                              </div>
                            </div>
                          </Col>
                        );
                      })}
                    </Row>
                  </div>
                );
              })
          )}
        </Container>
      </div>

      {/* Floating Bottom Cart Pill */}
      <div className="floating-cart-bar" onClick={handleShowCart}>
        <span>
          {totals.totalProducts} items . ₹ {totals.discountRate.toFixed(2)}
        </span>
        <span className="mx-1">|</span>
        <span className="floating-cart-badge-container">
          <FaShoppingCart style={{ fontSize: "1.2rem" }} />
          {totals.totalProducts > 0 && (
            <span className="floating-cart-badge">{totals.totalProducts}</span>
          )}
        </span>
        <span>View Cart</span>
      </div>

      <>
        <Modal show={show} onHide={handleClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              <div className="regular">
                {" "}
                {selectedProduct && selectedProduct.name}
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="mx-auto">
            <table>
              <tbody>
                <tr>
                  <td className="text-center image_video" colSpan="2">
                    <div className="text-center mx-auto w-25">
                      {selectedProduct &&
                        (selectedProduct.img ? (
                          <img
                            src={selectedProduct.img}
                            className="img-fluid"
                            alt="Product"
                          />
                        ) : (
                          <img
                            src={require("../../assets/images/storelogo.png")}
                            className="img-fluid"
                            alt="Product Placeholder"
                          />
                        ))}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <table>
              <tbody>
                <tr>
                  {selectedProduct && selectedProduct.img && (
                    <td>
                      <div className="dual">
                        <img
                          src={selectedProduct.img}
                          className="img-fluid"
                          alt="product"
                        />
                      </div>
                    </td>
                  )}
                  {selectedProduct && selectedProduct.video_url && (
                    <td>
                      <div className="w-25 mx-auto">
                        <div
                          className="play-icon"
                          onClick={handleVideoModalShow}
                        >
                          <FaPlay />
                        </div>
                      </div>
                    </td>
                  )}
                </tr>
              </tbody>
            </table>
          </Modal.Footer>
        </Modal>
        {showVideoModal && (
          <Modal show={showVideoModal} onHide={handleVideoModalClose} centered>
            <Modal.Header closeButton>
              <Modal.Title>
                {selectedProduct && selectedProduct.name}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <iframe
                width="100%"
                height="400"
                src={`https://www.youtube.com/embed/${extractVideoId(
                  selectedProduct.video_url
                )}`}
                frameBorder="0"
                allowFullScreen
                title="Product Video"
              />
            </Modal.Body>
          </Modal>
        )}
      </>
      {/* Product Modal end */}
      {/* cart table start */}
      <Offcanvas
        show={showCart}
        onHide={handleCloseCart}
        scroll="true"
        placement="end"
      >
        <PageTitle onClick={handleCloseCart} title={companydata.company_name} />
        <Offcanvas.Body>
          <div className="canvas-table regular">
            <div className="cart-table">
              <BootstrapTable>
                <tbody>
                  {cart.map((cart) => (
                    <tr key={cart.id}>
                      <td className="w-75">
                        <div className="product-name pb-1 fw-bold">{cart.name}</div>
                        <div className="d-flex align-items-center gap-1 mt-1">
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-danger px-2 py-0 fw-bold"
                            style={{ minWidth: "28px" }}
                            onClick={() => {
                              if (cart.qty > 1) {
                                updateQuantity(cart.id, -1);
                                addToCart({
                                  id: cart.id,
                                  action: "minus",
                                });
                              } else {
                                removeProduct(cart.id);
                              }
                            }}
                          >
                            -
                          </button>
                          <input
                            className="form-control form-control-sm text-center fw-bold px-1"
                            style={{ width: "45px" }}
                            value={cart.qty}
                            readOnly
                          />
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-success px-2 py-0 fw-bold"
                            style={{ minWidth: "28px" }}
                            onClick={() => {
                              updateQuantity(cart.id, 1);
                              addToCart({
                                id: cart.id,
                                action: "plus",
                              });
                            }}
                          >
                            +
                          </button>
                        </div>
                      </td>
                      <td className="text-end">
                        <div className="pb-2">
                          {" "}
                          <Close
                            label={
                              <>
                                <FaTimes />
                              </>
                            }
                            onClick={() => removeProduct(cart.id)}
                          />{" "}
                        </div>
                        <div className="price_total">
                          ₹<span>{cart.total_price}</span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </BootstrapTable>
            </div>
          </div>
          <div className="bottom-table">
            <BootstrapTable>
              <tr>
                <td>
                  <tr>
                    <td className="w-100"> Total Net Rate Amount :</td>
                    <td>
                      {" "}
                      ₹<span>{totals.overallTotal.toFixed(2)}</span>
                    </td>
                  </tr>
                </td>
              </tr>
              <tr>
                <td>
                  <tr>
                    <td className="w-100"> Total Discount Amount :</td>
                    <td>
                      {" "}
                      ₹<span>{totals.discountedOverallTotal.toFixed(2)}</span>
                    </td>
                  </tr>
                </td>
              </tr>
              <tr>
                <td>
                  <tr>
                    <td className="w-100"> Total Amount :</td>
                    <td>
                      {" "}
                      ₹<span>{totals.discountRate.toFixed(2)}</span>
                    </td>
                  </tr>
                </td>
              </tr>
            </BootstrapTable>
          </div>
          {/* Minimum Order Info Banner */}
          <div className="p-3 my-3 rounded-3" style={{ background: "linear-gradient(135deg, #FFFDF5 0%, #FFF8E7 100%)", border: "1px solid #FFE0B2" }}>
            <div className="fw-bold text-dark mb-2 text-center" style={{ fontSize: "0.9rem" }}>
              <FaInfoCircle className="text-warning me-1" /> Minimum Order Requirements
            </div>
            <div className="d-flex justify-content-center gap-2 flex-wrap text-center">
              <span className="badge bg-white text-danger border border-danger px-3 py-2 shadow-sm rounded-pill">
                Tamil Nadu: <strong>₹3,000</strong>
              </span>
              <span className="badge bg-white text-dark border border-secondary px-3 py-2 shadow-sm rounded-pill">
                Other States: <strong>₹5,000</strong>
              </span>
            </div>
          </div>

          <div className="text-center my-3">
            {totals.discountRate >= 3000 ? (
              <Buttons
                label={<>Confirm Estimate & Checkout ➔</>}
                fullWidth={"100%"}
                onClick={() => {
                  showOut();
                  handleCloseCart();
                }}
              ></Buttons>
            ) : (
              <div className="alert alert-warning py-2 px-3 mb-0 text-center fw-bold" style={{ fontSize: "0.85rem" }}>
                Add ₹{(3000 - totals.discountRate).toFixed(0)} more items to reach minimum order (₹3,000)
              </div>
            )}
          </div>

          {/* Terms and Conditions Section */}
          <div className="terms-section mt-4">
            <h5 className="bold"><FaCheckCircle className="me-2" /> Terms & Conditions</h5>
            <div className="terms-card-item">
              <FaCheckCircle className="text-success mt-1 flex-shrink-0" />
              <div>
                <strong>Minimum Order Value:</strong> Tamil Nadu - ₹3,000 | Other States - ₹5,000
              </div>
            </div>
            <div className="terms-card-item">
              <FaTruck className="text-primary mt-1 flex-shrink-0" />
              <div>
                <strong>Transportation Charges:</strong> Extra (as per actual parcel transport)
              </div>
            </div>
            <div className="terms-card-item">
              <FaClock className="text-warning mt-1 flex-shrink-0" />
              <div>
                <strong>Delivery Time:</strong> Tamil Nadu - 4 Days, Other States - 10 Days
              </div>
            </div>
            <div className="terms-card-item">
              <FaCalendarAlt className="text-danger mt-1 flex-shrink-0" />
              <div>
                <strong>Price List Validity:</strong> Valid for Diwali 2026 season
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      {/* cart table end */}
      {/* customer details start */}
      <>
        <Offcanvas show={checkout} scroll="true" placement="end">
          <PageTitle onClick={closeOut} title={companydata.company_name} />
          <Offcanvas.Body>
            <div className="customer-details regular">
              <div className="canvas-table regular">
                <Container>
                  <Row>
                    <Col lg="12" className="py-2">
                      <DropDowns
                        options={Object.keys(districtData).map((state) => ({
                          value: state,
                          label: state,
                        }))}
                        placeholder={"Select State"}
                        label={"Select State"}
                        name="state"
                        value={{ value: formData.state, label: formData.state }}
                        onChange={handleStateChange}
                      />
                    </Col>
                    <Col lg="12" className="py-2">
                      <Forms
                        placeholder={"Enter City / District"}
                        label={"Enter City / District"}
                        name="city"
                        value={formData.city || ""}
                        onChange={(e) => handleChange(e, "city")}
                      />
                    </Col>
                    <Col lg="12" className="py-2">
                      <Forms
                        placeholder={"Enter the name"}
                        label={"Enter the Name"}
                        name="name"
                        value={formData.name}
                        onChange={(e) => handleChange(e, "name")}
                      />
                    </Col>
                    <Col lg="12" className="py-2">
                      <Forms
                        placeholder={"Enter the Mail"}
                        label={"Enter the Mail"}
                        name="email"
                        value={formData.email}
                        onChange={(e) => handleChange(e, "email")}
                      />
                    </Col>
                    <Col lg="12" className="py-2">
                      <Forms
                        placeholder={"Mobile No."}
                        label={"Mobile No."}
                        name="mobile"
                        value={formData.mobile}
                        onChange={(e) => handleChange(e, "mobile")}
                      />
                    </Col>
                    <Col lg="12" className="py-2">
                      <div className="py-2">
                        {" "}
                        <label> Address</label>
                      </div>
                      <textarea
                        placeholder="Address"
                        className="w-100"
                        name="address"
                        value={formData.address}
                        onChange={(e) => handleChange(e, "address")}
                      />
                    </Col>
                  </Row>
                </Container>
              </div>
              <div className="bottom-table">
                <BootstrapTable>
                  <tr>
                    <td>
                      <tr>
                        <td className="w-100"> Total Net Rate Amount :</td>
                        <td>
                          {" "}
                          ₹<span>{totals.overallTotal.toFixed(2)}</span>
                        </td>
                      </tr>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <tr>
                        <td className="w-100"> Total Discount Amount :</td>
                        <td>
                          {" "}
                          ₹<span>{totals.discountedOverallTotal.toFixed(2)}</span>
                        </td>
                      </tr>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <tr>
                        <td className="w-100"> Total Amount :</td>
                        <td>
                          {" "}
                          ₹<span>{totals.discountRate.toFixed(2)}</span>
                        </td>
                      </tr>
                    </td>
                  </tr>
                </BootstrapTable>
              </div>
              <div className="d-flex justify-content-evenly">
                <div className="text-center regular py-3 w-100 mx-2">
                  <Buttons
                    label={
                      isSubmitting ? (
                        <>
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="me-2"
                          />
                          Submitting...
                        </>
                      ) : (
                        <>Submit</>
                      )
                    }
                    className="w-100"
                    fullWidth={"100%"}
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                  ></Buttons>
                </div>
                <div className="text-center regular py-3 w-100 mx-2">
                  <Buttons
                    label={<>Cancel</>}
                    fullWidth={"100%"}
                    onClick={closeOut}
                    disabled={isSubmitting}
                  ></Buttons>
                </div>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </>
      {/* customer details end */}
      {/* order preview modal start*/}
      <>
        <Modal
          show={showEstimate}
          onClick={closeModal}
          centered
          className="regular"
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title className="bold">Order Preview</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container fluid>
              <Row>
                <Col lg="12">
                  <div className="text-center py-3">
                    <div> {companydata.company_name}</div>
                    <div>{companydata.address}</div>
                    <div> Phone No :{companydata.phone}</div>
                  </div>
                  <div className="text-center">Estimated Successfully</div>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          <Modal.Footer>
            <PDFDownloadLink
              document={<Bill data={printData} />}
              fileName="estimate.pdf"
            >
              <Buttons label={<>Download PDF</>} onClick={closeModal} />
            </PDFDownloadLink>
          </Modal.Footer>
        </Modal>
      </>
      {/* Full Preview Modal for Combos */}
      {/* 
      <Modal
        show={Boolean(previewCombo)}
        onHide={() => setPreviewCombo(null)}
        centered
        size="xl"
        className="combo-modal-preview"
      >
        {previewCombo && (
          <div className="combo-modal-content">
            <Modal.Header closeButton className="combo-modal-head">
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <span className="combo-badge-pill m-0 position-static">{previewCombo.badge}</span>
                <Modal.Title className="combo-modal-heading m-0">
                  {previewCombo.name} - Items & Price List
                </Modal.Title>
              </div>
            </Modal.Header>
            <Modal.Body className="combo-modal-body text-center p-2 p-md-3">
              <div className="combo-fullview-container">
                <img
                  src={previewCombo.image}
                  alt={previewCombo.name}
                  className="combo-full-img img-fluid"
                />
              </div>
            </Modal.Body>
            <Modal.Footer className="combo-modal-foot d-flex justify-content-between align-items-center flex-wrap gap-2">
              <div className="combo-foot-note">
                🌟 Sivakasi Direct Factory Price | Valid for Diwali 2026 Season
              </div>
              <button
                type="button"
                className="btn combo-close-btn"
                onClick={() => setPreviewCombo(null)}
              >
                Close Preview ✕
              </button>
            </Modal.Footer>
          </div>
        )}
      </Modal>
      */}

      {/* Professional Customer Alert Modal */}
      <Modal
        show={alertModal.show}
        onHide={closeAlert}
        centered
        backdrop="static"
        keyboard={true}
        className="regular"
        size="md"
      >
        <div style={{ borderRadius: "14px", overflow: "hidden", border: "1px solid #FFE0B2" }}>
          <div
            className="p-3 text-white text-center d-flex align-items-center justify-content-center gap-2"
            style={{
              background: alertModal.type === "danger"
                ? "linear-gradient(135deg, #DC2626 0%, #B91C1C 100%)"
                : "linear-gradient(135deg, #07173E 0%, #0D3B82 100%)",
            }}
          >
            <FaExclamationTriangle style={{ fontSize: "1.4rem", color: "#FFD700" }} />
            <h5 className="m-0 fw-bold">{alertModal.title}</h5>
          </div>
          <Modal.Body className="p-4 text-center">
            <p className="mb-0 text-dark fw-bold" style={{ fontSize: "1.05rem", lineHeight: "1.6" }}>
              {alertModal.message}
            </p>
          </Modal.Body>
          <Modal.Footer className="justify-content-center border-0 pb-4 pt-0">
            <button
              type="button"
              className="btn text-white fw-bold px-4 py-2"
              style={{
                background: "linear-gradient(135deg, #07173E 0%, #0D3B82 100%)",
                borderRadius: "25px",
                minWidth: "160px",
                border: "1.5px solid #FFD700",
                boxShadow: "0 4px 12px rgba(7, 23, 62, 0.35)",
              }}
              onClick={closeAlert}
            >
              Continue Shopping 🛒
            </button>
          </Modal.Footer>
        </div>
      </Modal>

      {/* Order Submission Loading Modal */}
      <Modal
        show={isSubmitting}
        centered
        backdrop="static"
        keyboard={false}
        className="order-loading-modal"
      >
        <div
          className="text-center p-4"
          style={{
            background: "linear-gradient(135deg, #07173E 0%, #0D3B82 100%)",
            borderRadius: "16px",
            border: "2px solid #FFD700",
            boxShadow: "0 15px 40px rgba(0, 0, 0, 0.45)",
            color: "#FFFFFF",
          }}
        >
          <div className="mb-3 position-relative d-inline-block">
            <Spinner
              animation="border"
              role="status"
              style={{
                width: "3.5rem",
                height: "3.5rem",
                color: "#FFD700",
                borderWidth: "0.25em",
              }}
            />
            <span
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                fontSize: "1.2rem",
              }}
            >
              💥
            </span>
          </div>
          <h4 className="fw-bold mb-2" style={{ color: "#FFD700", letterSpacing: "0.5px" }}>
            Processing Your Order...
          </h4>
          <p className="mb-2 fw-semibold" style={{ color: "#FDE68A", fontSize: "1rem" }}>
            உங்கள் ஆர்டர் பதிவு செய்யப்படுகிறது...
          </p>
          <p className="small text-white-50 mb-0">
            Please wait a moment while we confirm your fireworks estimate.
          </p>
        </div>
      </Modal>
    </>
  );
};

export default CardThree;

const StyledTable = styled(BootstrapTable)`
  margin-bottom: 0 !important;
  background-color: #6482ad;
  border: 0;
  border-color: #6482ad;
  color: #fff;
  font-family: "regular";
  & th,
  & td {
    text-align: center;
    background-color: #6482ad;
    vertical-align: middle;
    color: #fff;
  }
`;
const Category = styled.div`
  background-color: #0c1c49;
  border: 0;
  border-color: #0c1c49;
  color: white;
  text-align: center;
  padding: 10px 0;
  font-size: 18px;
  font-family: "bold";
`;
const Calc = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Input = styled.input`
  border: none;
  outline: none;
  padding: 4px;
  width: 60px;
  text-align: center;
  background: transparent;
`;
